export const operationsPaths = {
  refin: 'operations/refin',
  refinDetails: 'operations/refin/:operationId/details',
} as const;
